"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
DiscountService.$inject = ['api'];
function DiscountService(api) {
}
exports.DiscountService = DiscountService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/discount/services/discount.js
// module id = 399
// module chunks = 0